
import { useEffect } from "react"
import { isChunkLoadError, reloadOnChunkError } from "@/lib/chunk-error"

/**
 * Global listener for chunk load failures during navigation.
 * Error boundaries only catch render errors — this catches async failures
 * from the router when it can't load a page chunk.
 */
export function ChunkErrorRecovery() {
  useEffect(() => {
    function handleError(event: ErrorEvent) {
      if (isChunkLoadError(event.error ?? event.message)) {
        event.preventDefault()
        reloadOnChunkError()
      }
    }

    function handleRejection(event: PromiseRejectionEvent) {
      if (isChunkLoadError(event.reason)) {
        event.preventDefault()
        reloadOnChunkError()
      }
    }

    window.addEventListener("error", handleError)
    window.addEventListener("unhandledrejection", handleRejection)

    return () => {
      window.removeEventListener("error", handleError)
      window.removeEventListener("unhandledrejection", handleRejection)
    }
  }, [])

  return null
}
